import type { ConversationListItem } from '@captivateiq/assistant/types';

/**
 * Filters over whatever conversations are already loaded in memory. There is no server-side
 * search endpoint (`GetConversationsQueryParams` has no `search` field) so this cannot reach
 * conversations on pages that haven't been fetched yet.
 */
export const filterConversationsBySearch = (
  conversations: ConversationListItem[],
  query: string,
): ConversationListItem[] => {
  const trimmed = query.trim().toLowerCase();
  if (!trimmed) {
    return conversations;
  }
  return conversations.filter((conversation) => (conversation.name ?? '').toLowerCase().includes(trimmed));
};
